import React, { createContext, useContext, useState } from "react";

type FolderTreeState = {
  openFolders: Set<number>;
  toggleFolder: (id: number) => void;
  isFolderOpen: (id: number) => boolean;
};

const FolderTreeContext = createContext<FolderTreeState | null>(null);

export const FolderTreeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openFolders, setOpenFolders] = useState<Set<number>>(new Set());

  const toggleFolder = (id: number) => {
    setOpenFolders((prev) => {
      const updated = new Set(prev);
      if (updated.has(id)) {
        updated.delete(id);
      } else {
        updated.add(id);
      }
      return updated;
    });
  };

  const isFolderOpen = (id: number) => openFolders.has(id);

  return (
    <FolderTreeContext.Provider value={{ openFolders, toggleFolder, isFolderOpen }}>
      {children}
    </FolderTreeContext.Provider>
  );
};

export const useFolderTree = () => {
  const context = useContext(FolderTreeContext);
  if (!context) {
    throw new Error("useFolderTree must be used within FolderTreeProvider");
  }
  return context;
};
